"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomOption = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CustomOption = function CustomOption(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    highlightedRef = _ref.highlightedRef,
    index = _ref.index,
    isHighlighted = _ref.isHighlighted,
    isSelected = _ref.isSelected,
    _onMouseDown = _ref.onMouseDown,
    value = _ref.value;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('px-[16px] py-[8px] text-left', {
      'bg-grey-15': isSelected || isHighlighted
    }, isSelected ? 'tw-body-sm-medium' : 'tw-body-sm-light', disabled ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer select-none', className),
    onMouseDown: function onMouseDown() {
      return _onMouseDown({
        index: index,
        value: value
      });
    },
    ref: isHighlighted ? highlightedRef : null
  }, children);
};
exports.CustomOption = CustomOption;